import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import PartnerForm from '@/modules/partner/components/PartnerForm.vue';
import { Partner, usePartner } from '@/modules/partner/Partner';
import { handleLoadError } from '@/core/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'PartnerEdit',
  setup(__props) {

const { $gettext } = useGettext();
const route = useRoute();
const router = useRouter();
const partner = ref<Partner | null>(null);

const load = async () => {
	try {
		const response = await usePartner().get(route.params.id as string);
		if (response) {
			partner.value = response;
		}
	} catch (e) {
		handleLoadError(e as Error, 'partner.index');
	}
};

watch(route, () => {
	if (route.params.id) {
		load();
	}
});
onBeforeMount(load);

const saved = (u) => {
	partner.value = u;
	Flash.success($gettext('Återförsäljaren har sparats.'));
};

const cancel = () => {
	router.push({ name: 'partner.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PartnerForm, {
    "page-title": _unref($gettext)('Redigera återförsäljare'),
    partner: partner.value,
    onSaved: saved,
    onCancel: cancel,
    "for-create": false
  }, null, 8, ["page-title", "partner"]))
}
}

})